export default __webpack_public_path__ + "static/media/Figure-12.b04e9c51.jpg";